module.exports = __webpack_public_path__ + "img/governance_intro.0c86d58c.png";